export default __webpack_public_path__ + "static/media/C229253.02c1f58f.jpg";